import React from 'react';
import styled from 'styled-components';

import { MiniPage, PublicPage } from 'api/website';
import { Box } from 'components/Box';
import { PrimaryButton } from 'components/Button';
import Icon from 'components/Icon/Icon';
import Link from 'components/Link';
import { BodySmall } from 'components/Text';
import { colors, gutterWidth, shadows, transition } from 'theme';

const BreadCrumbs = styled(Box)`
  * {
    display: inline;
  }
`;
const Input = styled.input`
  width: 100%;
  height: 50px;
  padding: 0 100px 0 18px;
  border-radius: 4px;
  background: ${colors.platinum};
  box-shadow: 0 0 0 2px ${colors.platinum} inset;
  appearance: none;
  border: 0;
  color: ${colors.greyishBrown};
  outline: 0;
  font-size: 18px;
  transition: all ${transition};
  &:focus {
    background: white;
    border: 0;
    box-shadow: 0 0 0 2px ${colors.waterBlue} inset;
  }
`;
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition, import/no-default-export
export default ({
  content,
  homePage,
  searchMode,
}: {
  content: PublicPage;
  homePage: MiniPage;
  searchMode: boolean;
}) => {
  const isHomePage = homePage && homePage.url === content.url;
  const hasBreadcrumbs = !isHomePage || (isHomePage && searchMode);
  return (
    <Box
      position="relative"
      zIndex={1}
      py={12}
      px={gutterWidth / 2}
      classes={['flex', 'align-center', 'justify-between']}
      flexWrap="wrap"
      bg={colors.white}
      borderTop={`1px solid ${colors.platinum}`}
      boxShadow={shadows.toolbar}
    >
      <Box width="50%" flex="0 0 auto" pr={16}>
        {hasBreadcrumbs && (
          <BreadCrumbs
            alignItems="center"
            data-qa-id="breadcrumbs"
            whiteSpace="nowrap"
            overflow="hidden"
            textOverflow="ellipsis"
          >
            <BodySmall color={colors.battleshipGrey}>
              <Link href={`/${content.subsite && homePage.url}`}>
                {content.subsite && homePage.title}
              </Link>
            </BodySmall>
            {!isHomePage && (
              <>
                <Box mx={16}>
                  <Icon
                    name="chevron"
                    width={9}
                    height={5}
                    direction="right"
                    display="block"
                  />
                </Box>
                <BodySmall styleAs="h5">
                  <Link href={`/${content.url}`}>{content.title}</Link>
                </BodySmall>
              </>
            )}
          </BreadCrumbs>
        )}
      </Box>
      <Box width={586} maxWidth="50%" justifyContent="flex-end" display="flex">
        <form
          action={`/${homePage.url}`}
          target="_top"
          data-initialize-from-url
        >
          <Box display="flex" position="relative">
            <input name="searchMode" value="true" hidden />
            <Input
              name="pq"
              placeholder={getText('Search articles')}
              data-allow-initialization
            />
            <Box position="absolute" top="7px" right="7px">
              <Box
                component={PrimaryButton}
                type="submit"
                small
                square
                minWidth={80}
              >
                {getText('Search')}
              </Box>
            </Box>
          </Box>
        </form>
      </Box>
    </Box>
  );
};
